import React from 'react';
import { Box, Typography, Button, ButtonBase, Paper } from '@mui/material';
import { Link, useNavigate, useParams } from 'react-router-dom';
import CustomAppBar from '../components/CustomAppBar';
import Navbar from '../components/Navbar';
import PrimaryButton from '../components/PrimaryButton';
import AppContainer from '../components/AppContainer';
import TextContainer from '../components/TextContainer';
import SectionBanner from '../components/SectionBanner';
import CloseIcon from '@mui/icons-material/Close';
import GroupListItem from '../components/GroupListItem';
import GroupsIcon from '@mui/icons-material/Groups';
import SectionBanner2 from '../components/SectionBanner2';
import { Grid } from '@mui/material';
// redux
import { useDispatch, useSelector } from 'react-redux';
import { updateTitle, updateSubtitle } from '../redux/doneSlice';
import { updateHeart, updateHeartOnReduxAndServer} from '../redux/heartSlice';
import { updateGroupOnReduxAndServer } from '../redux/groupSlice';
import { PRIMARY_COLOR } from '../colorPalette';
import { publishMessage } from '../api/mqtt';
import { MQTT_TOPIC_PREFIX, MAX_GROUP_SIZE } from '../constants';
import { useSnackbar } from 'notistack';
import { GroupSchema, HeartSchema } from 'lumas-shared-schemas';


function AddHeartToGroup () {
    const navigate = useNavigate();
    const params = useParams();
    const dispatch = useDispatch();
    const {enqueueSnackbar} = useSnackbar();

    // get groups from the store
    const groups = useSelector((state) => state.group.groups);
    const hearts = useSelector((state) => state.heart.hearts);
    // Get current heart information
    const heart = hearts.find((heart) => heart.id === params?.heartId);
    const user = useSelector((state) => state.user.user);

    // handle the group item click
    const handleClick = (clickedGroup) => {
        // get the ID and group information of the clicked group
        console.log("group information", clickedGroup)

        // update group property of heart, validating heart object against schema
        const updatedHeart = HeartSchema.parse({
            ...heart, 
            group: clickedGroup.id
        });

        // Prevent adding heart to a group at MAX_GROUP_SIZE
        if (clickedGroup.hearts.length === MAX_GROUP_SIZE) {
            console.error("Cannot add to group, group at maximum group size. Group size:", clickedGroup.hearts.length, ". Max group size:", MAX_GROUP_SIZE);
            enqueueSnackbar(`"Cannot add to group, group at maximum group size. Group size: ${clickedGroup.hearts.length}. Max group size: ${MAX_GROUP_SIZE}`, {variant: 'error'});
            return;
        }
        console.log("Group size below maximum group size limit. Group size:", clickedGroup.hearts.length, ". Max group size:", MAX_GROUP_SIZE)

        // 1. remove the heart from the old group in the store (if any) -- Is this necessary??
        console.log("Heart group id", heart, heart.group)
        const oldGroup = groups.find((group) => group.id === heart.group);
        console.log("old group", oldGroup);
        if(oldGroup) {
            // remove the heart ID from the old group's hearts array, validating group object against schema
            const updatedOldGroup = GroupSchema.parse({
                ...oldGroup, 
                hearts: oldGroup.hearts.filter((heartID) => heartID !== params?.heartId)
            });
            dispatch(updateGroupOnReduxAndServer({id: oldGroup.id, updatedGroup: updatedOldGroup}))
            console.log("removed heart from old group!");   
        }

        // Send DATABASE_UPDATE to old group
        const old_group_topic = MQTT_TOPIC_PREFIX + heart.group + "/dbUpdate"
        publishMessage(old_group_topic, "DATABASE_UPDATE", false)

        // 2. add the ID of heart to the new Group in the store, validating against schema
        const updatedGroup = GroupSchema.parse({
            ...clickedGroup, 
            hearts: [...clickedGroup.hearts, params?.heartId]
        });
        dispatch(updateGroupOnReduxAndServer({id: clickedGroup.id, updatedGroup: updatedGroup}));

        // 3. update the group property of the Heart in the store
        dispatch(updateHeartOnReduxAndServer({id: params?.heartId, updatedHeart: updatedHeart}))

        console.log("Hearts", hearts);
        
        // update the Done title and subtitle in the store
        dispatch(updateTitle(`Heart added to ${clickedGroup.name} successfully!`));
        dispatch(updateSubtitle("You can start changing the color of the heart now."));

        // Send "DATABASE_UPDATE" to LumasHearts/groups/[groupID]/dbUpdate
        const topic = MQTT_TOPIC_PREFIX + clickedGroup.id + "/dbUpdate"
        publishMessage(topic, "DATABASE_UPDATE", false)

        console.log("Clicked!")

        navigate(`/manage-heart/${params?.heartId}/add-to-group/done`);
    }
    
    return (
        <AppContainer>
            <Box style={{ display: 'flex', flexDirection: 'column', minHeight: window.innerHeight }}>
                {/* Box to fill space, pushing button to bottom of screen */}
                <Box style={{ flex: 1 }}>
                <CustomAppBar />
                    <Navbar rightButtonIcon={<CloseIcon />} title={"Add Heart to Group"} rightButtonOnClick={() => {navigate('/home')}} />
                    <TextContainer>
                        {/* <Typography variant='h5'>Add Heart to Group</Typography> */}
                        <Typography variant='body2' sx={{marginTop: '15px', fontStyle: 'italic', fontSize: '12px', textAlign: 'center'}}>
                            <>
                                Select a group to add your heart {' '} 
                                <Box component="span" sx={{ color: PRIMARY_COLOR }}>
                                    {heart.name}
                                </Box>
                                {' '}to.
                            </>
                        </Typography>
                    </TextContainer>
                    <SectionBanner2 text={"Your Groups"} IconComponent={GroupsIcon} customStyles={{marginTop: '25px'}} />
                    <TextContainer>
                        {/* List your groups here */}
                        {groups.map((group, index) => (
                            // exclude the group the heart is already part of, if any
                            group.id !== heart.group.id &&
                            <Grid item key={index} sx={{width: '100%'}}>
                                <GroupListItem groupName={group.name} numberMembers={group.members.length} numberHearts={group.hearts.length} onClick={() => {handleClick(group)}} />
                            </Grid>
                        ))}
                        {/* Render this if groups is empty */}
                        {groups.length === 0 && (
                            <Box sx={{display:'flex', justifyContent: 'center'}}>
                                <Typography variant='body2' fontStyle={"italic"}>You have no available groups.</Typography>
                            </Box>
                        )}
                        <Typography variant='body2' sx={{fontSize: '12px', fontStyle: 'italic', marginTop: '20px', textAlign: 'center'}}>Not seeing the group you want? Add a group below.</Typography>
                        <Button variant={"outlined"} sx={{marginTop: '5px', width: '100%'}} onClick={() => {navigate(`/add-group?heartId=${params?.heartId}`)}}>Add a Group</Button>
                    </TextContainer>
                </Box>
                {/* Button at the bottom of the screen */}
                {/* <TextContainer customStyles={{marginBottom: '40px'}}>
                    <PrimaryButton text={"Join Group"} customStyles={{width: '100%'}} onClick={() => {navigate(`/manage-heart/${params?.heartId}/join-group/done`)}}/>
                </TextContainer> */}
            </Box>
        </AppContainer>
    )
}

export default AddHeartToGroup